// extracted by mini-css-extract-plugin
module.exports = {"connect_button":"ConnectButton_connect_button__2bP9y","provider_image":"ConnectButton_provider_image__2wh_C"};